
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11.44","cy":"24.6","r":"9.57","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M16.45 32.69h21.68L27.29 5.66l-6.62 16.49M11.5 29v10.67M14.45 26.98l-2.95 2.95-2.94-2.95M27.29 30v9.67"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M30.23 26.98l-2.94 2.95-2.95-2.95M11.15 10.06a2.58 2.58 0 010-5.16 2.62 2.62 0 011 .21 3.86 3.86 0 113.71 5z"}})])
          )
        }
      }
    